// ST-1258 -Claude- Nearrme web entry.
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { I18nextProvider } from 'react-i18next';
import { i18n, i18nReady } from './i18n';
import { ThemeProvider } from './theme/ThemeProvider';
import { App } from './App';
import { initClarity } from './analytics/clarity';
import { initGoogleTag } from './analytics/googleTag';
import './index.css';

initClarity();
initGoogleTag();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // ST-1289 -Claude- Stale-while-revalidate so offline cached data renders instantly.
      staleTime: 5 * 60 * 1000, // 5 min
      gcTime: 24 * 60 * 60 * 1000, // 24h cache
      retry: 2,
      refetchOnWindowFocus: true,
    },
  },
});

function renderApp() {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <I18nextProvider i18n={i18n}>
        <ThemeProvider>
          <QueryClientProvider client={queryClient}>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </QueryClientProvider>
        </ThemeProvider>
      </I18nextProvider>
    </React.StrictMode>
  );
}

void i18nReady.then(renderApp).catch((error: unknown) => {
  console.error('Failed to initialize i18n', error);
  renderApp();
});
